import React from 'react';

interface PaymentIconProps {
  method: string;
  className?: string;
}

export const PaymentIcon = ({ method, className = "w-12 h-12" }: PaymentIconProps) => {
  const icons: Record<string, React.ReactElement> = {
    'Visa': (
      <svg viewBox="0 0 60 40" className={className} fill="currentColor">
        <rect width="60" height="40" rx="3" fill="#1434CB"/>
        <path d="M25 15h-4l-1.5 8h4l1.5-8zm7 0c-1 0-1.8.3-2.3.8l-3 7.2h4l.4-1h2.4l.2 1h3.5l-2-8h-3.2zm-1.2 5l.8-2 .5 2h-1.3zm6.2-5h-3.5l-2 8h3.5l2-8z" fill="white"/>
      </svg>
    ),
    'Mastercard': (
      <svg viewBox="0 0 60 40" className={className} fill="currentColor">
        <rect width="60" height="40" rx="3" fill="white"/>
        <circle cx="22" cy="20" r="9" fill="#EB001B"/>
        <circle cx="38" cy="20" r="9" fill="#F79E1B"/>
        <path d="M30 14c1.8 2.4 2.8 5.2 2.8 8.2s-1 5.8-2.8 8.2c-1.8-2.4-2.8-5.2-2.8-8.2s1-5.8 2.8-8.2z" fill="#FF5F00"/>
      </svg>
    ),
    'PayPal': (
      <svg viewBox="0 0 60 40" className={className} fill="currentColor">
        <rect width="60" height="40" rx="3" fill="#0070BA"/>
        <path d="M18 12h-5l-2 10h5l2-10zm-1.5 7.5c-.1.5-.4.8-.9.8h-1.5l.5-2.5h1.5c.5 0 .8.3.9.8l-.5 1zm9-7.5h-5l-2 10h5l2-10zm-1.5 7.5c-.1.5-.4.8-.9.8h-1.5l.5-2.5h1.5c.5 0 .8.3.9.8l-.5 1z" fill="white"/>
      </svg>
    ),
    'Skrill': (
      <svg viewBox="0 0 60 40" className={className} fill="currentColor">
        <rect width="60" height="40" rx="3" fill="#6C00FF"/>
        <rect x="18" y="16" width="24" height="8" rx="1" fill="white"/>
      </svg>
    ),
    'Neteller': (
      <svg viewBox="0 0 60 40" className={className} fill="currentColor">
        <rect width="60" height="40" rx="3" fill="#00AFED"/>
        <circle cx="30" cy="20" r="6" fill="white"/>
        <path d="M26 20l2 2 4-4" stroke="#00AFED" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    'Bitcoin': (
      <svg viewBox="0 0 60 40" className={className} fill="currentColor">
        <circle cx="30" cy="20" r="15" fill="#F7931A"/>
        <path d="M28 12v2.5h-2v1.5h2v1h-2v1.5h2v2.5c-1.5.2-2.5 1-2.5 2.5 0 1.8 1.2 2.5 2.5 2.5v2.5h1.5v-2.5h2v-1.5h-2v-1h2v-1.5h-2v-2.5c1.5-.2 2.5-1 2.5-2.5 0-1.8-1.2-2.5-2.5-2.5v-2.5h-1.5zm-1 6.5c.8 0 1.2.5 1.2 1s-.4 1-1.2 1v-2zm1 5.5c.8 0 1.2.5 1.2 1s-.4 1-1.2 1v-2z" fill="white"/>
      </svg>
    ),
    'Ethereum': (
      <svg viewBox="0 0 60 40" className={className} fill="currentColor">
        <rect width="60" height="40" rx="3" fill="#627EEA"/>
        <path d="M30 12l-6 10 6-3 6 3-6-10zm-6 13l6 3 6-3-6 9-6-9z" fill="white"/>
      </svg>
    ),
    'Bank Transfer': (
      <svg viewBox="0 0 60 40" className={className} fill="currentColor">
        <rect width="60" height="40" rx="3" fill="none" stroke="currentColor" strokeWidth="2"/>
        <rect x="12" y="14" width="36" height="2" fill="currentColor"/>
        <rect x="12" y="19" width="28" height="2" fill="currentColor"/>
        <rect x="12" y="24" width="32" height="2" fill="currentColor"/>
        <circle cx="48" cy="20" r="5" fill="currentColor"/>
      </svg>
    )
  };

  return icons[method] || (
    <svg viewBox="0 0 48 32" className={className} fill="currentColor">
      <rect x="8" y="8" width="32" height="16" rx="2" fill="currentColor"/>
    </svg>
  );
};

